import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'

// import LanguageDetector from 'i18next-browser-languagedetector'
import en_translation from './locales/en/translation.json'
import uk_translation from './locales/uk/translation.json'
// import fr_translation from './locales/fr/translation.json'
import { DEFAULT_LANGUAGE, IS_DEV } from '../constants'

// translation catalog
const resources = {
  en: {
    translation: en_translation,
  },
  uk: {
    translation: uk_translation,
  },
  // fr: {
  //   translation: fr_translation,
  // },
}

i18n
  // .use(LanguageDetector)
  // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init({
    fallbackLng: DEFAULT_LANGUAGE,
    debug: IS_DEV,
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
    resources,
    compatibilityJSON: 'v4',
  })

export default i18n
